const userInfoFields = [
  {
    key: 'name',
    label: 'field.name',
    rules: 'required',
    type: 'text',
  },
  {
    key: 'phone',
    label: 'field.phoneNumber',
    rules: 'required',
    type: 'tel',
  },
  {
    key: 'loginTimeout',
    label: 'field.loginTimeout',
    rules: 'required|integer',
    type: 'text',
  },
]

const betConfigFields = [
  {
    key: 'maxBetTime',
    label: 'field.maxBetTime',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetGame',
    label: 'field.maxBetGame',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxWinDay',
    label: 'field.maxWinDay',
    rules: 'required|decimal:2',
    type: 'currency',
  },
]

export const internalCreateFields = [
  ...userInfoFields,
  ...betConfigFields,
  {
    label: 'breadcrumb.accountInformation',
    icon: 'LockIcon',
    type: 'divider',
  },
  {
    key: 'parentId',
    label: 'field.underAccount',
    rules: 'required',
    type: 'asynSingleSelection',
    repository: 'agent',
    selectionKey: 'id',
    selectionLabel: 'username',
  },
  {
    key: 'username',
    label: 'field.username',
    rules: 'required|alpha_num',
    type: 'text',
  },
  {
    key: 'password',
    name: 'new-password',
    label: 'field.password',
    rules: 'required|min:6',
    type: 'password',
    hideInView: true,
  },
  {
    key: 'retypePassword',
    label: 'field.retypePassword',
    rules: 'required|confirmed:password',
    type: 'password',
    hideInView: true,
  },
  {
    key: 'isEnable',
    label: 'status.active',
    rules: '',
    type: 'checkbox',
    cols: 'auto',
  },
  {
    key: 'isReadonly',
    label: 'status.readonly',
    rules: '',
    type: 'checkbox',
    cols: 'auto',
  },
]

export const internalUpdateFields = [
  ...userInfoFields,
  ...betConfigFields,
  {
    label: 'breadcrumb.accountInformation',
    icon: 'LockIcon',
    type: 'divider',
  },
  {
    key: 'parentUsername',
    label: 'field.underAccount',
    rules: 'required',
    type: 'text',
    disabled: true,
  },
  {
    key: 'username',
    label: 'field.username',
    rules: 'required|alpha_num',
    type: 'text',
    disabled: true,
  },
  {
    key: 'password',
    name: 'new-password',
    label: 'field.password',
    rules: 'min:6',
    type: 'password',
    hideInView: true,
  },
  {
    key: 'retypePassword',
    label: 'field.retypePassword',
    rules: 'confirmed:password',
    type: 'password',
    hideInView: true,
  },
  {
    key: 'isEnable',
    label: 'status.active',
    rules: '',
    type: 'checkbox',
    cols: 'auto',
  },
  {
    key: 'isReadonly',
    label: 'status.readonly',
    rules: '',
    type: 'checkbox',
    cols: 'auto',
  },
]

export const externalFields = [
  {
    key: 'name',
    label: 'field.name',
    type: 'text',
    disabled: true,
  },
  {
    key: 'loginTimeout',
    label: 'field.loginTimeout',
    rules: 'required|integer',
    type: 'text',
  },
  ...betConfigFields,
  {
    label: 'breadcrumb.accountInformation',
    icon: 'LockIcon',
    type: 'divider',
  },
  {
    key: 'parentUsername',
    label: 'field.underAccount',
    rules: 'required',
    type: 'text',
    disabled: true,
  },
  {
    key: 'username',
    label: 'field.username',
    rules: 'required',
    type: 'text',
    disabled: true,
  },
  {
    key: 'isEnable',
    label: 'status.active',
    rules: '',
    type: 'checkbox',
    cols: 'auto',
  },
  {
    key: 'isReadonly',
    label: 'status.readonly',
    rules: '',
    type: 'checkbox',
    cols: 'auto',
  },
]
